import Highlight from './highlight.png';
import * as React from 'react';

interface IProps {
	className?: string;
	height?: string | number;
	width?: string | number;
}

export const HighlightIcon: React.FC<IProps> = ({ className = '', height = 20, width = 20 }) => {
	return <img className={className} src={Highlight} alt='highlight icon' width={width} height={height} />;
};
